import request from '@/api/request';
const defaultRequest = request();

export function GoogleMapDirections (params) {
  return defaultRequest({
    url: 'map/directions',
    method: 'get',
    params
  });
}

export function GoogleMapGeoCodeding (address) {
  return defaultRequest({
    url: 'map/geocoding',
    method: 'get',
    params: {
      address
    }
  });
}

export function FastMapDirections (params) {
  return defaultRequest({
    url: 'fastmap/routing',
    method: 'get',
    params
  });
}

export function FastMapGeoCodeding (address) {
  return defaultRequest({
    url: 'fastmap/geocoding',
    method: 'get',
    params: {
      address
    }
  });
}



// WEBPACK FOOTER //
// ./src/api/map.js